import React from 'react';
import { MapPin } from 'lucide-react';
import type { Service } from '../../types';

interface ServiceCenterHeroProps {
  service: Service;
  brandName?: string;
  location?: {
    state?: string;
    city?: string;
    area?: string;
  };
}

export default function ServiceCenterHero({ service, brandName, location }: ServiceCenterHeroProps) {
  // Generate location string based on available data
  let locationString = '';
  if (location) {
    if (location.area && location.city) {
      locationString = `${location.area}, ${location.city}`;
    } else if (location.city && location.state) {
      locationString = `${location.city}, ${location.state}`;
    } else if (location.state) {
      locationString = location.state;
    }
  }

  return (
    <div className="relative bg-blue-600">
      <div className="max-w-7xl mx-auto py-12 sm:py-16 px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          {locationString && (
            <div className="flex items-center justify-center text-blue-200 mb-4">
              <MapPin className="h-5 w-5 mr-2 flex-shrink-0" />
              <span className="truncate">{locationString}</span>
            </div>
          )}
          
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-white tracking-tight mb-4">
            AC, Refrigerator, TV, Microwave, Washing Machine Service Center
            {locationString && (
              <span className="block text-2xl mt-2 text-blue-100">
                in {locationString}
              </span>
            )}
          </h1>
          
          <p className="mt-4 max-w-2xl mx-auto text-base sm:text-lg text-blue-100 line-clamp-3">
            Professional repair services with expert technicians, genuine spare parts, and 90-day warranty
          </p>
        </div>
      </div>
    </div>
  );
}